import {
  getCompanyFormList,
  getCompanyList,
  pathCreateCompany,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { companyActions } from "../reducers/company";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchCompanyList = (id_company = 0) => {
  return (dispatch) => {
    return apiService
      .get(getCompanyList(id_company))
      .then((response) => {
        id_company == 0
          ? dispatch(companyActions.fetchCompanyList(response.data))
          : dispatch(companyActions.fetchCompanyDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCompanyFormList = (id_company = 0) => {
  return (dispatch) => {
    return apiService
      .get(getCompanyFormList(id_company))
      .then((response) => {
        dispatch(companyActions.fetchCompanyFormList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCompanyFormListClear = () => {
  return (dispatch) => {
    dispatch(companyActions.fetchCompanyFormListClear());
  };
};

export const createNewCompany = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .post(pathCreateCompany(), data)
      .then((response) => {
        // dispatch(companyActions.fetchCompanyList(response.data));
        toast.success(t("companyListActions.created"), {
          theme: "colored",
        });
        navigate("/company-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEditCompany = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .put(pathCreateCompany(), data)
      .then((response) => {
        // dispatch(companyActions.fetchCompanyList(response.data));
        toast.success(t("companyListActions.updated"), {
          theme: "colored",
        });
        navigate("/company-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
